module.exports = __webpack_public_path__ + "03a257b2a065b846e898755d1403cedb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-bg03.png
// module id = 836
// module chunks = 3